<template>
  <div>
    <!-- 点击订单详情自动弹出 -->
    <el-dialog :close-on-click-modal="false"
      title="详情"
      :visible.sync="infoDialogVisible"
      :before-close="infoHandleClose"
      width="59.4%"
      center
      top="15vh"
    >
      <el-divider></el-divider>
      <div class="infoTable">
        <div class="infoDiv">
          <div>
            <span>景区名称</span>
            <span>阿考虑过哈伦裤改好了</span>
          </div>
          <div>
            <span>注:</span>
            <span>价格仅支持整数,出现小数讲把小数抹为0</span>
          </div>
        </div>
        <div>
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            :header-cell-style="tableHeaderColor"
            :cell-style="cellStyle"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="name" label="产品名称">
              <!-- <template slot-scope="scope">{{ scope.row.date }}</template> -->
            </el-table-column>
            <el-table-column prop="name" label="建议价格"></el-table-column>
            <el-table-column prop="address" label="最低售卖价"></el-table-column>
            <el-table-column prop="address" label="有效期"></el-table-column>
            <el-table-column prop="address" label="支持退货">
              <template slot-scope="scope">
                <img src="@/images/distributor/kt.png" alt />
                <img src="@/images/distributor/bkt.png" alt />
              </template>
            </el-table-column>
            <el-table-column prop="address" label="预定数量"></el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  data() {
    return {
      orderInfoDialogVisible: false, // 产品详情
      infoDialogVisible: false, // 产品详情
      form: {
        name: ""
      },
      tableData: [
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄"
        },
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄"
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄"
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄"
        },
        {
          date: "2016-05-08",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄"
        },
        {
          date: "2016-05-06",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄"
        },
        {
          date: "2016-05-07",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄"
        }
      ],
      multipleSelection: []
    };
  },
  methods: {
    // 产品详情
    orderInfo(row) {
      this.infoDialogVisible = true;
      this.orderInfoDialogVisible = true;
    },
    infoHandleClose() {
      this.infoDialogVisible = false;
    },
    // 产品详情X
    orderInfoHandleClose() {
      this.orderInfoDialogVisible = false;
    },
    // 详情全选
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
.infoTable {
  .infoDiv {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    > div:nth-child(1) {
      > span:nth-child(1) {
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 18px;
        text-align: center;
        color: #000000;
        margin-right: 10px;
      }
    }
    > div:nth-child(2) {
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #e74c3c;
      > span:nth-child(1) {
        margin-right: 10px;
      }
    }
  }
}
.infoForm {
  /deep/.el-form-item__label {
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
  }
  .itemOne {
    display: flex;
    flex-wrap: wrap;
    .el-input {
      width: 330px;
    }
  }
  .itemTwo {
    display: flex;
    flex-wrap: wrap;
    .el-input {
      width: 176.7px;
    }
  }
  .itemThree {
    display: flex;
    > div:nth-child(1) {
      .el-input {
        width: 100px;
      }
    }
    > div:nth-child(2) {
      .el-input {
        width: 560px;
      }
    }
  }
  .itemFour {
    display: flex;
    flex-wrap: wrap;
    .el-input {
      width: 165px;
    }
    span {
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      margin: 0 10px;
    }
  }
  .itemFive {
    display: flex;
    .el-input {
      width: 300px;
      margin-right: 20px;
    }
    /deep/.el-input__inner {
      border: none;
      background: #f7f7fa;
      border-radius: 4px;
      color: #246deb;
    }
    .el-button {
      width: 110px;
      background: #ffffff;
      border: 1px solid #246deb;
      border-radius: 4px;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #246deb;
    }
  }
}
/deep/.el-dialog__header {
  height: 60px;
  line-height: 60px;
  padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  color: #000000;
}
/deep/.el-dialog__headerbtn {
  position: absolute;
  top: 5px;
  right: 20px;
  padding: 0;
  background: 0 0;
  border: none;
  outline: 0;
  cursor: pointer;
  font-size: 16px;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
</style>